/**
 * Apples to Apples' content: a deck. Two kinds rather than one with a colour field, so item
 * CRUD validates a green as a green and each half is countable.
 */
import { z } from 'zod';
/** A layout limit: cards render as phone buttons, seven to a screen. */
export const MAX_CARD_TEXT = 90;
const cardBody = z.object({
    text: z.string().trim().min(1).max(MAX_CARD_TEXT),
});
/** Same shape as a red, declared separately so `schemas` keyed by kind keeps them apart. */
export const greenBodySchema = cardBody;
/** A red apple: the noun a player plays. */
export const redBodySchema = cardBody;
/** A hand can outlive the item it names when a host edits the deck mid-game. */
export function cardText(content, id) {
    return content.cards.get(id)?.text ?? '(a card that was removed)';
}
/** Skips an unparseable item rather than throwing: a bad card costs one card, not the deck. */
function resolve(items) {
    const greens = [];
    const reds = [];
    const cards = new Map();
    const ordered = [...items].sort((a, b) => a.position - b.position || (a.id < b.id ? -1 : a.id > b.id ? 1 : 0));
    for (const item of ordered) {
        if (item.kind !== 'green' && item.kind !== 'red')
            continue;
        const parsed = cardBody.safeParse(item.body);
        if (!parsed.success)
            continue;
        const card = { id: item.id, kind: item.kind, text: parsed.data.text };
        cards.set(card.id, card);
        (card.kind === 'green' ? greens : reds).push(card);
    }
    return { greens, reds, cards };
}
export const applesContent = {
    schemas: {
        green: greenBodySchema,
        red: redBodySchema,
    },
    /**
     * Deliberately low: a host halfway through writing a deck should not be locked out.
     * `reduce.ts` copes with a thin deck.
     */
    minItems: 2,
    resolve,
};
//# sourceMappingURL=content.js.map